<template>
  <div v-cloak class="my-profile-contailer">

    <div class="table">
      <el-table
        ref="basicFormTable"
        :data="data"
        border
      >
        <template v-for="(table, childIdx) in tableList">
          <el-table-column

                           :label="table.view_field_label"
                           :min-width="table.table_field_column_width">
            <template slot-scope="scope">

             <span v-if="scope.row[table.db_field_name + '_change']" style="color: blue"> {{ scope.row[table.db_field_name] }}</span>
             <span v-else > {{ scope.row[table.db_field_name] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>

  export default {
    props:{
      data:{
        type: Array,
        required: true,
        default: () => []
      }
    },
    watch:{

    },
    components: {

    },
    data() {
      return {
        tableList:[
          {
            view_field_label: 'Banner ID',
            table_field_column_width: 100,
            db_field_name: 'banner_id'
          },
          {
            view_field_label: 'Banner CN',
            table_field_column_width: 100,
            db_field_name: 'banner_name_cn'
          },
          {
            view_field_label: 'Banner EN',
            table_field_column_width: 120,
            db_field_name: 'banner_name_en'
          },
          {
            view_field_label: 'Channel',
            table_field_column_width: 100,
            db_field_name: 'channel_type_code'
          },
          {
            view_field_label: 'Banner Type',
            table_field_column_width: 120,
            db_field_name: 'banner_type_code'
          },
          {
            view_field_label: 'Banner Group CN',
            table_field_column_width: 150,
            db_field_name: 'banner_group_name_cn'
          },
          {
            view_field_label: 'Banner Group EN',
            table_field_column_width: 150,
            db_field_name: 'banner_group_name_en'
          },
        ]

      }
    },
    computed: {
    },
    created() {
      console.info(this.data);
    },


    methods: {

    }
  }

</script>

<style lang="scss" scoped>
  .my-profile-contailer {
    padding: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/view/store/banner_master/banner_modify.vue